import type { ITimelineSettings } from "../types";

export const makeTimelineComboAttributes = (settings: ITimelineSettings) => ({
  "data-timeline-type": settings.timelineType,
  "data-timeline-style": settings.timelineStyle,
  "data-timeline-set-container": settings.timelineSetContainer,
  "data-timeline-position": settings.timelinePosition,
  "data-timeline-marker": settings.timelineMarker,
  ...(settings.timelineContentWrapping && {
    "data-timeline-content-wrapping": settings.timelineContentWrapping,
  }),
  ...(settings.timelineSnakeOrder && {
    "data-timeline-snake": "true",
  }),
});
